module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_28 (35).9382780.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_28 (35).mp4
// module id = 810
// module chunks = 1